
document.addEventListener('DOMContentLoaded', () => {

  const searchToggle = document.querySelector('.search-toggle');
  const searchPopup = document.querySelector('#search-popup');
  const searchClose = document.querySelector('.search-close');
  const searchOverlay = document.querySelector('.search-popup-overlay');
  const searchInput = document.querySelector('.search-input');

  if (searchToggle && searchPopup) {
    searchToggle.addEventListener('click', () => {
      searchPopup.classList.add('open');
      searchPopup.classList.remove('hidden');
      searchInput?.focus();
    });
  }

  const closeSearch = () => {
    if (searchPopup) {
      searchPopup.classList.remove('open');
      searchPopup.classList.add('hidden');
    }
  };

  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchOverlay) searchOverlay.addEventListener('click', closeSearch);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchPopup?.classList.contains('open')) {
      closeSearch();
    }
  });

  const mobileUserToggle = document.querySelector('.mobile-user-toggle');
  const mobileUserMenu = document.querySelector('.mobile-user-menu');

  if (mobileUserToggle && mobileUserMenu) {
    mobileUserToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      mobileUserMenu.classList.toggle('hidden');
      mobileUserMenu.classList.toggle('open');
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.mobile-user-menu-wrap')) {
        mobileUserMenu.classList.add('hidden');
        mobileUserMenu.classList.remove('open');
      }
    });
  }

  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileNavOverlay = document.querySelector('.mobile-nav__overlay');
  const mobileNavClose = document.querySelector('.mobile-nav__close');

  if (hamburger) {
    hamburger.addEventListener('click', () => {
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }

  const closeMobileNav = () => {
    if (mobileNav) {
      mobileNav.classList.remove('open');
      document.body.style.overflow = '';
    }
  };

  if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);

  document.querySelectorAll('.quantity-input-wrap').forEach(wrap => {
    const input = wrap.querySelector('.qty-input');
    const minus = wrap.querySelector('[data-qty="minus"]');
    const plus = wrap.querySelector('[data-qty="plus"]');

    if (minus) {
      minus.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      });
    }

    if (plus) {
      plus.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        input.value = val + 1;
      });
    }
  });

  document.querySelectorAll('.tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      const container = btn.closest('.product-tabs');

      container.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
      container.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));

      btn.classList.add('active');
      const panel = container.querySelector(`[data-panel="${target}"]`);
      if (panel) panel.classList.add('active');
    });
  });

  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('unavailable')) return;

      const group = btn.closest('.variant-group');
      group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');

      const selectedLabel = group.querySelector('.variant-selected');
      if (selectedLabel) selectedLabel.textContent = btn.getAttribute('data-value') || btn.textContent;
    });
  });

  const addToCartForm = document.querySelector('[data-add-to-cart-form]');

  if (addToCartForm) {
    addToCartForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      const submitBtn = addToCartForm.querySelector('[data-add-to-cart]');
      const originalText = submitBtn?.textContent;

      if (submitBtn) {
        submitBtn.textContent = 'Adding...';
        submitBtn.disabled = true;
      }

      const formData = new FormData(addToCartForm);

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });

        if (res.ok) {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          updateCartCount(cart.item_count);

          if (submitBtn) {
            submitBtn.textContent = '✓ Added!';
            setTimeout(() => {
              submitBtn.textContent = originalText;
              submitBtn.disabled = false;
            }, 2000);
          }
        } else {
          throw new Error('Add to cart failed');
        }
      } catch (err) {
        console.error(err);
        if (submitBtn) {
          submitBtn.textContent = 'Error — Try Again';
          submitBtn.disabled = false;
        }
      }
    });
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  (function hydrateCartCount() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(r => r.ok ? r.json() : null)
      .then(cart => { if (cart) updateCartCount(cart.item_count); })
      .catch(() => { /* offline / blocked: leave count hidden */ });
  })();

  const announcementClose = document.querySelector('.announcement-bar__close');
  const announcementBar = document.querySelector('.announcement-bar');

  if (announcementClose && announcementBar) {
    announcementClose.addEventListener('click', () => {
      announcementBar.style.display = 'none';
      sessionStorage.setItem('announcementClosed', 'true');
    });

    if (sessionStorage.getItem('announcementClosed') === 'true') {
      announcementBar.style.display = 'none';
    }
  }


});
